export default __webpack_public_path__ + "static/yongyang-58db60c687ee5b383206b8214e785b74.jpg";